import { createContext } from "react";
// Create the timezone context
export const TimezoneContext = createContext("Asia/Kolkata");
// Create the TimezoneProvider component
export const TimezoneProvider = ({ children }: any) => {
  const timezone = "Asia/Kolkata";
  // Function to update the timezone
  // const updateTimezone = (newTimezone : any) => {
  //   setTimezone(newTimezone);
  // };
  // Value object to be provided to consuming components
  // const value = {
  //   timezone,
  //   updateTimezone,
  // };
  return (
    <TimezoneContext.Provider value={timezone}>
      {children}
    </TimezoneContext.Provider>
  );
};